//import logo from './vc1logo.png';
import './assets/App.css';
import React from 'react';
//import { Button } from '@material-ui/core';
import AppTopNav from './components/core/AppTopNav';
import AppLeftNav from './components/core/AppLeftNav';
import ErrorHandler from './components/core/UserNotice';
import Login from './components/core/Login';
import { makeStyles } from '@material-ui/core/styles';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import Dashboard from './components/dashboard/Dashboard';
import Signs from './components/signs/Signs';
import Sign from './components/signs/Sign';
import SignMap from './components/signs/Map';
import SignTypes from './components/signs/Types';
import SignOptions from './components/signs/Options';
import Organization from './components/organization/Organization';
import Ph5Options from './components/configuration/ph5/Settings';
import WSocket from './components/socket/Test';
import StatFiles from './components/signs/StatFiles';
import AddSign from './components/signs/AddSign';

const drawerWidth = 180;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up('md')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  visitorcontent : {
	flexGrow: 1,
	marginTop:64
  },
  content: {
    flexGrow: 1,
	[theme.breakpoints.up('md')]: {
		marginLeft: drawerWidth
	},
	marginTop:64
    //padding: theme.spacing(3),
  },
}));
/*

  */

function App() {
  	const classes = useStyles();
  	//const theme = useTheme();
	const [mobileOpen, setMobileOpen] = React.useState(false);
	const [user, setUser] = React.useState({});
	const [altUser, setAltUser] = React.useState({});
	const [organization, setOrganization] = React.useState({});
	const [loaded, setLoaded] = React.useState(false);
	const [errorOpen, setErrorOpen] = React.useState(false);
	const [error, setError] = React.useState(false);
	const [successOpen, setSuccessOpen] = React.useState(false);
	const [successMessage, setSuccessMessage] = React.useState(false);
	const [loginOpen, setLoginOpen] = React.useState(false);
	const [history, setHistory] = React.useState([]);
	const handleDrawerToggle = () => {
    	setMobileOpen(!mobileOpen);
  	};
	/*
	const isEmpty = (obj) => {
		var out = true;
		for(var n in obj){
			out = false;
			break;
		}
		return out;
	}
	*/
	const handleError = (newerror) => {
		setError(newerror);
		setErrorOpen(true);
		if(newerror.code === 1){
			setLoginOpen(true);
		}
	}
	
	const handleSend = (postvars, callback) => {
	  fetch(window.location.origin+'/admin.php?action=vso&ajax=app', {
        	method:'POST',
		    credentials: 'include',
		    headers: {
				'Content-Type':'application/json',
				'Accept':'application/json'
			},
        	body: JSON.stringify(postvars)
      	  }).then((response) => {
			  return response.json();
		  }).then((data) => {
			  console.log(data);
		  	  if(data.error){
				  console.log("we received an error");
				  console.log(data.error);
				  handleError(data.error);
				  if(postvars.vso !== 'usersession' && data.error.code === 1){
					  var lastaction = {
					  	postvars : postvars,
					  	callback : callback
				  	};
				  	setHistory(Object.assign([], history).push(lastaction));
				  }
			  } else {
				if(data.successMessage){
					setSuccessOpen(true);
					setSuccessMessage(data.successMessage);
				}
		  	  	if(callback){
				  	callback(data);
			  	}
			  }
		  });
	};
	const getUserSession = () =>{
		setLoaded(true);
		handleSend({
			vso: 'usersession'
		}, (data) => {
			setUser(data.user);
			setOrganization(data.organization);
			if(history.length > 0){
				var newhist = Object.assign([], history);
				var lastact = newhist.pop();
				setSuccessOpen(true);
				setSuccessMessage("Replaying last action");
				handleSend(lastact.postvars, lastact.callback);
				setHistory(newhist);
			}
		})
		
	}
	React.useEffect(() => {
		if(!loaded){
			getUserSession();
			//setLoaded(true);
			//handleSend({
			//	vso: 'usersession'
			//}, (data) => {
			//	setUser(data.user);
			//	setOrganization(data.organization);
			//});
		}
	});
	
  return (
    <div>
	  <BrowserRouter basename={process.env.PUBLIC_URL}>
	  <AppTopNav
	  	handleDrawerToggle={handleDrawerToggle}
	    user={user}
	    organization={organization}
	  	login={setLoginOpen}
	  	handleSend={handleSend}
		setUser={setUser}
		altUser={altUser}
		setAltUser={setAltUser}
	  />
	  <AppLeftNav
	  	mobileOpen={mobileOpen}
	    handleDrawerToggle={handleDrawerToggle}
	    setDrawer={setMobileOpen}
		user={user}
	  />
	  <div className={!user || !user.usergroup ? classes.visitorcontent : classes.content}>
	  
	    <Routes>
	  	  <Route path="/" element={<Dashboard />} />
	  	  <Route path="/map" element={<SignMap handleSend={handleSend} user={user} />} />
	      <Route path="/signs" element={<Signs handleSend={handleSend} user={user} organization={organization} />} />
	  	  <Route path="/sign/:id" element={<Sign handleSend={handleSend} user={user} />} />
		  <Route path="/sign/:id/:tab" element={<Sign handleSend={handleSend} user={user} />} />
	  	  <Route path="/types" element={<SignTypes handleSend={handleSend} user={user} />} />
	  	  <Route path="/options" element={<SignOptions handleSend={handleSend} user={user} />} />
	  	  <Route path="/organization/:id" element={<Organization 
		  	handleSend={handleSend} 
			organization={organization} 
			onChange={setOrganization} 
			user={user} 
			setUser={setUser}
			altUser={altUser}
			setAltUser={setAltUser}
			/>} />
	  	  <Route path="/ph5_settings" element={<Ph5Options handleSend={handleSend} user={user} />} />
		  <Route path="/statfiles/:id" element={<StatFiles handleSend={handleSend} user={user} organization={organization} />} />
		  <Route path="/socket" element={<WSocket />} />
		  <Route path="/addsign" element={<AddSign api={handleSend} user={user} organization={organization} />} />
	    </Routes>
	  
      
	 </div>
	  <ErrorHandler
	  	errorOpen={errorOpen}
	    setErrorOpen={setErrorOpen}
	    error={error}
	    successOpen={successOpen}
	    setSuccessOpen={setSuccessOpen}
	    message={successMessage}
	  />
	  <Login
	    setLoginOpen={setLoginOpen}
	    loginOpen={loginOpen}
	    handleSend={handleSend}
	    getUserSession={getUserSession}
	  />
	  </BrowserRouter>
    </div>
  );
}

export default App;
